export const convertCreatePromotions = data => {
  const resultData = {
    lang: data.lang,
    image: data.imageData?.base64?.split(',')[1],
    image_ext: data.imageData?.ext,

    mini_image: data.bannerData?.base64?.split(',')[1],
    mini_image_ext: data.bannerData?.ext,

    is_active: data.active,
    url: data.url,
    call_action: data.callToAction,
    header: data.title,
    short_description: data.shortDescription,
    description: data.fullDescription,
  };

  Object.keys(resultData).forEach(key => resultData[key] === undefined && delete resultData[key]);

  return resultData;
};
